import {call, put, takeLatest, delay} from 'redux-saga/effects';
import {RETRIEVE_MAP_REQUEST, CANCEL_RETRIEVE_MAP_REQUEST, SET_MAP_REQUEST} from '../actions/mapDownload';
import config from '../config';
import {getAnalyticsReferrerPolicy} from '../cookieConsent';


export function* getMapRequestSaga(action) {
    const mapRequestId = action.payload;
    let receivedPaidFiles = false;
    try {
        let remaining = config.pollingTime;
        while (true) {
            const response = yield call(fetch, `${config.apiHost}/map/api/map-requests/${mapRequestId}`, {
                referrerPolicy: getAnalyticsReferrerPolicy(),
            });

            if (!response.ok) throw new Error('API error!');

            const data = yield response.json();
            const images = data.paid_images;
            if (!images?.preview || !images.download?.png) throw new Error('API data error!');

            yield put({
                type: SET_MAP_REQUEST,
                payload: {
                    previewUrl: images.preview,
                    downloadPngUrl: images.download.png,
                    downloadPdfUrl: images.download.pdf,
                    downloadTifUrl: images.download.tif,
                },
            });
            receivedPaidFiles = true;

            if ((images.download.pdf && images.download.tif) || remaining <= 0) return;
            yield delay(config.pollingSleep * 1000);
            remaining -= config.pollingSleep;
        }
    } catch (e) {
        console.error(e);
        if (!receivedPaidFiles) yield put({type: SET_MAP_REQUEST, payload: {}});
    }
}

export function* watchRetrieveMapRequest() {
    yield takeLatest([RETRIEVE_MAP_REQUEST, CANCEL_RETRIEVE_MAP_REQUEST], function* (action) {
        if (action.type === RETRIEVE_MAP_REQUEST) yield call(getMapRequestSaga, action);
    });
}
